// src/components/ui/card.jsx
import React from "react";
import clsx from "clsx";

export const Card = ({ children, className = "", ...rest }) => (
  <div
    className={clsx("bg-white dark:bg-gray-800 rounded-card-lg border border-gray-100 dark:border-gray-700 shadow-sm", className)}
    {...rest}
  >
    {children}
  </div>
);

export const CardHeader = ({ children, className = "" }) => (
  <div className={clsx("px-4 py-3 border-b border-gray-100 dark:border-gray-700", className)}>{children}</div>
);

export const CardTitle = ({ children, className = "" }) => (
  <h3 className={clsx("font-semibold text-lg text-gray-900 dark:text-gray-100", className)}>
    {children}
  </h3>
);

export const CardContent = ({ children, className = "" }) => <div className={clsx("p-4", className)}>{children}</div>;

export default Card;
